<template>
  <div class="agreement">
    <div class="agreement">
      <div class="agreementTitle">优越服务车主卡会员服务协议</div>
      <div class="agreementmesgtitle">欢迎使用优越服务为您提供的车主卡会员服务。</div>
      <div class="agreementmesgtitle">【特别提示】</div>
      <div  class="agreementmesgtitle">为了保障您 (以下简称 “用户”)的权益，请在使用<span style="font-weight: 400;">优越服务车主卡</span>会员服务之前，详细阅读、理解<span style="font-weight: 400;">《优越服务车主卡会员服务协议》</span>(以下简称 “本协议”)。特别是以加粗或下划线形式提示您注意的条款。该协议构成用户与<span style="font-weight: 400;">优越服务</span>达成的协议，具有法律效力。本协议是《<span style="font-weight: 400;">优越服务</span>用户协议》的补充协议，是其不可分割的组成部分，与其构成统一整体。本协议与上述内容存在冲突的，以本协议为准。</div>
      <div class="agreementmesgtitle1">当您按照<span style="font-weight: 400;text-decoration: none">优越服务</span>会员开通页面的指引，点击“立即开通”按钮或其他类似含义的按钮时，即视为您已充分阅读、理解本协议，同意成为<span style="font-weight: 400;text-decoration: none">优越服务车主卡</span>会员，并自愿受本协议的约束。您在阅读本协议过程中，如果您不同意或不理解本协议或其中任何条款，您应立即停止开通并停止使用<span style="font-weight: 400;text-decoration: none">优越服务车主卡</span>会员服务。</div>
      <div  class="agreementmesgtitle">本服务协议（以下称“本协议”）由您与广东优越车网<span style="text-decoration: underline">信息技术有限公司</span>（以下简称“优越车网”或“我们“）共同签署。</div>
      <div class="agreementmesgtitle1">本“特别提示”是本协议正文的组成部分。</div>
      <div class="agreementmesgtitle">一、定义与解释</div>
      <div class="agreementmesgtitle"><span style="font-weight: 400;">1.1优越服务车主卡</span>会员：指同意并接受本协议，并根据优越服务公布的收费标准通过线上支付费用方式确认和绑定会员资格并获取特定权益的优越服务用户。会员资格不可转让。</div>
      <div class="agreementmesgtitle">二、会员资格的开通和获取</div>
      <div class="agreementmesgtitle"><span style="font-weight: 400;">2.1</span><span class="agreementmesgtitle1">会员的服务、收费标准（包括制定不同会员权益、价格等）可能会进行调整，并在会员购买页面向您展示。</span>您同意您继续操作的行为（包括但不限于点击同意购买、支付行为、继续使用会员服务的行为等），即视为您知悉并同意相关调整。您己开通会员服务的，在您开通的服务有效期内，收费标准以调整前服务费用为准。有效期满后，您需要续费及重新开通的，则需按照调整后的收费标准支付会员服务费用。</div>
      <div class="agreementmesgtitle"><span style="font-weight: 400;">2.2</span>请您在开通和使用会员服务过程中确认您已具备完全民事行为能力，如您不具备签署主体资格，您需要在父母或监护人的监护参与下方能接受本协议并购买会员服务。提交申请会员购买时，用户同意并提交本人手机号码、邮箱等优越服务所需的个人资料，并保证其提供的注册资料真实、准确、完整、合法有效，用户注册资料如有变动的，应及时更新其注册资料。如果用户提供的注册资料不合法、不真实、不准确、不详尽，用户需承担因此引起的相应责任及后果，并且我们保留停止向您提供会员服务的权利。</div>
      <div class="agreementmesgtitle"><span style="font-weight: 400;">2.3</span>基于会员服务为虛拟服务，您在购买会员服务后，除优越服务无法正常提供会员全部服务的原因外，如您中途取消已购买的会员服务或终止会员资格，将无法获得为购买会员服务而支付的费用退还或其他任何形式的补偿/赔偿。</div>
      <div class="agreementmesgtitle"><span style="font-weight: 400;">2.4</span>我们收到您开通会员请求后将会进行审核，如未能开通成功，我们将及时退还您相关款项。</div>
      <div class="agreementmesgtitle">三、会员权益的使用</div>
      <div class="agreementmesgtitle"><span style="font-weight: 400;">3.1</span>会员年度会员有效期为365天，自付费成功当日起计算，除发生不可抗力、意外事件及我司运营中断等情况外，有效期限一般不发生中断或中止。有效期将至时可通过续费延续会员资格有效时间，续费会员的资格有效期自届满日次日起算。服务有效期届满后，会员资格自动失效。</div>
      <div class="agreementmesgtitle"><span style="font-weight: 400;">3.2</span>会员服务提供的各项专属权益服务均有有效期限，请您在购买时务必认真阅读会员规则内容或相关页面提示，您一旦购买会员即视为认可会员服务及各项专属权益的有效期限。</div>
      <div class="agreementmesgtitle"><span style="font-weight: 400;">3.3</span>为保证您的账户安全和会员权益，会员服务以优越服务的账号作为识别，一旦账号购买会员不可转让及借给他人使用，否则用户应承担由此产生的全部责任，包括但不限于会员权益的限制、资格取消等。</div>
      <div class="agreementmesgtitle"><span style="font-weight: 400;">3.4</span>您理解并同意，您选择向<span style="font-weight: 400;">优越服务</span>申请兑换<span style="font-weight: 400;">优越服务</span>自有权益及/或第三方异业权益时，视为您向<span style="font-weight: 400;">优越服务</span>披露个人相关信息，接受<span style="font-weight: 400;">优越服务</span>向您提供权益兑换、信息记录、信息更新、售后服务、客户服务、处理信用卡付款、数据分析、市场营销或其他必要事宜。如前述全部或部分事宜涉及由优越服务外的第三方供应商提供服务或履行的，优越服务有权将您的信息以必要方式向第三方披露，第三方供应商有权以提供服务或履行上述事宜为目的合法使用您的信息并联系您。</div>
      <div class="agreementmesgtitle"><span style="font-weight: 400;">3.5</span>用户通过京东账号操作的各项行为应符合法律法规规定、京东规则规定及用户注册协议及本协议约定，当出现违规行为（具体可参见：违规行为处理规则）、违规订单（具体可参见：违规订单处理规则）及违规账号（具体可参见：违规账号处理规则）时，京东有权按照上述规则对您的账号和订单予以处理。</div>
      <div class="agreementmesgtitle">四、会员权益的终止及解除</div>
      <div class="agreementmesgtitle"><span style="font-weight: 400;">4.1</span>如您利用会员资格从事非法或本协议及优越服务禁止的行为，我们有权随时终止您的会员资格并不负有任何责任。</div>
      <div class="agreementmesgtitle"><span style="font-weight: 400;">4.2</span>如优越服务基于 《优越服务用户协议》、本协议、京东规则等停止对您提供服务，亦将同时终止您的会员资格，服务停止及会员资格终止前您已获得的各项权益将无法使用。</div>
      <div class="agreementmesgtitle"><span style="font-weight: 400;">4.3</span>若用户中途因违反《优越服务用户协议》、本协议、京东规则被终止会员资格的，用户为开通会员服务而支付的费用将不予退还。</div>
      <div class="agreementmesgtitle"><span style="font-weight: 400;">4.4</span>优越服务有权根据自身商业决策等原因暂停及/或终止会员服务。除法律有明确规定的情况外，优越服务决定暂停会员服务的，有权经公示15日后为已开通会员办理延期，决定终止会员服务的，有权公示15日后为已开通用户办理退款。</div>
      <div class="agreementmesgtitle"><span style="font-weight: 400;">4.5</span>用户违规行为包含但不限于以下行为时，京东有权关闭您的会员开通资格、关停您已开通的会员服务，已绑定的或获取的会员权益被全部/部分取消或暂停使用，且不退换已支付的会员服务费用。从公平合理的角度，您应知晓所有通过该账户实现的操作产生的全部后果或损失由您自行承担。</div>
      <div class="agreementmesgtitle">1）利用会员服务进行盈利或非法获利；</div>
      <div class="agreementmesgtitle">2）以任何形式转让或转移会员服务或会员权益；</div>
      <div class="agreementmesgtitle">3）将会员服务或会员权益借给他人使用、代他人下单；</div>
      <div class="agreementmesgtitle">4）通过任何不正当手段或以违反城市信用原则的方式开通会员服务，如恶意绕过正常开通流程；</div>
      <div class="agreementmesgtitle">5）使用会员权益获取的商品或服务并非用于个人消费或使用；</div>
      <div class="agreementmesgtitle">6）同一用户注册、持有、使用或控制多个会员账号。其中，同一用户是指京东账户、手机号码、支付账号、身份证号码、设备号、注册信息、网络操作日志、交易订单信息等与用户身份和行为相关的信息，其中任意一项或数项存在相同、相似，亦或通过特定标记批量信息进行分析，其数项存在相同、相似的；</div>
      <div class="agreementmesgtitle">7）用户在使用会员服务时，存在利用秒杀器等工具下单、套取优惠利差、虚假下单交易、提供虚假交易信息等扰乱 交易秩序、违反交易规则的行为；</div>
      <div class="agreementmesgtitle">8）经京东判断，用户行为不符合公平原则或诚实信用原则的情形。</div>
      <div class="agreementmesgtitle">五、优越服务会员使用规范</div>
      <div class="agreementmesgtitle"><span style="font-weight: 400;">5.1</span>用户理解并保证，会员服务仅限本人使用，用户不得以任何形式将其享有的会员服务借予他人使用，不得以任何形式转让其享有的会员服务，不得利用会员服务获取非法利益。优越服务有合理理由怀疑用户存在前述行为的，有权取消用户优越服务会员资格。用户因前述行为给优越服务造成损失的，优越服务保留向户追偿的权利。</div>
      <div class="agreementmesgtitle"><span style="font-weight: 400;">5.2</span>优越服务有关会员活动及政策、规则的告知，在公示后即自动构成本协议补充内容，相关政策、规则有期间限制的，期间经过后即终止，本协议效力不受影响。优越服务有权以网站/app公告等方式进行不定期地制定、修改本协议及/或相关服务规则，该等更新将提前7日公示。用户在使用优越服务会员服务时，应当及时查阅了解修改的内容，并自觉遵守本协议的相关内容。用户如继续使用优越服务会员服务，则视为同意修改的内容。</div>
      <div class="agreementmesgtitle"><span style="font-weight: 400;">5.3</span>用户知悉并同意，优越服务有权通过邮件、短信、电话或其他通讯形式，向其发送相关活动信息。</div>
      <div class="agreementmesgtitle">六、其他说明</div>
      <div class="agreementmesgtitle"><span style="font-weight: 400;">6.1</span>本协议内容或公布的相关规则，您有权于变更事项确定的生效日前联系客服反馈意见。如意见得以采纳，将酌情调整变更事项。</div>
      <div class="agreementmesgtitle"><span style="font-weight: 400;">6.2</span>如遇不可抗力或其他优越服务无法控制的客观原因使优越服务会员权益无法按时实现，将与您联系处理相关善后事宜。</div>
      <div class="agreementmesgtitle"><span style="font-weight: 400;">6.3</span>您作为优越服务会员期间，享有一般用户权利义务，具体以《优越服务用户协议》为准。</div>
      <div class="agreementmesgtitle"><span style="font-weight: 400;">6.4</span>本协议的订立、执行和解释及争议的解决均应适用在中华人民共和国大陆地区适用之有效法律（但不包括其冲突法规则）。如发生本协议条款与适用法律相抵触时，则该等协议条款将按法律规定重新解释，而其它协议有效条款继续有效。</div>
      <div class="agreementmesgtitle"><span style="font-weight: 400;">6.5</span>如缔约双方就本协议内容或其执行发生任何争议，双方应尽力友好协商解决；协商不成时，任何一方均可向本协议签订地（北京市大兴区） 有管辖权的人民法院提起诉讼。</div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      phoneNumber: '',
    }
  },
  created() {
    this.phoneNumber  = sessionStorage.getItem("phoneNumber")
  },
  mounted() {

  },
  methods: {

  }
}
</script>

<style scoped>
.agreement {
  width: calc(100% - 40px);
  /* // margin: 20px; */
  padding: 20px;
  background-color: #FFFFFF;
}

.agreementTitle {
  font-size: 18px;
  font-weight: bold;
  text-align: center;
  margin-bottom: 20px;
}

.agreementmesgtitle {
  font-size: 14px;
  font-weight: bold;
  text-indent: 2em;
}
.agreementmesgtitle1 {
  font-size: 14px;
  font-weight: bold;
  text-decoration: underline;
  text-indent: 2em;
}

.agreementmesgtitlexie {
  font-size: 14px;
  font-weight: bold;
  /*    // font-style: italic; */
  text-decoration: underline
}

.agreementmesg {
  font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// src/pages/vipCard/vipPricacy.vue